import { render, staticRenderFns } from "./Recuperar.vue?vue&type=template&id=71984299&"
import script from "./Recuperar.vue?vue&type=script&lang=js&"
export * from "./Recuperar.vue?vue&type=script&lang=js&"
import style0 from "./Recuperar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports